<a class="toggle-container" (click)="toggleClick($event)">
  <div [ngClass]="toggleOn ? 'toggle-bg toggle-on' : 'toggle-bg'">
    <div [@toggleTrigger]="toggleOn ? 'on' : 'off' " class="toggle"></div>
  </div>
</a>